import _ from 'lodash';
import ROLES from '../../models/roles';
const BlankIntegrationInstance = require('./../../models/blankIntegrationInstance');

class ConfigureCustomerController {
  constructor(modalLoaderService, localStorageService, config, httpDim, customerService, customerIntegrationsService, customer) {
    this.name = 'configureCustomer';
    this.modalLoaderService = modalLoaderService;
    this.httpDim = httpDim;
    this.config = config;
    this.customerService = customerService;
    this.customerIntegrationsService = customerIntegrationsService;
    this.customer = customer;
    this.ssoEnabledValues = [{label: 'Yes', value: 1}, {label: 'No', value: 0}];
    this.adminRoleValues = [{label: 'Staff', value: 'staff'}, {label: 'Organization Administrator', value: 'organizational_admin'}, {label: 'Reporting Administrator', value: 'curriculum_reporter'}, {label: 'Curriculum Administrator', value: 'curriculum_manager'}];
    this.buipFormatValues = [{label: 'Name', value: 'Name'}, {label: 'ID + Name', value: 'ID_Name'}, {label: 'School Year + Name', value: 'SchoolYear_Name'}, {label: 'School Year + ID + Name', value: 'SchoolYear_ID_Name'}];
    this.importModeValues = [{label: 'Validate Only', value: 0}, {label: 'Validate and Update', value: 1}, {label: 'Validate and Replace', value: 2}];
    this.orchestrateDataValues = [{label: 'Yes', value: 1}, {label: 'No', value: 0}];
    this.defaultSsoEnabled = this.getDefaultSsoEnabled(this.ssoEnabledValues, this.customer);
    this.defaultBuipFormat = this.getDefaultBuipFormat(this.buipFormatValues, this.customer);
    this.defaultImportMode = this.getDefaultImportMode(this.importModeValues, this.customer);
    this.defaultOrchestrateData = this.getDefaultOrchestrateData(this.orchestrateDataValues, this.customer);
    this.defaultAdminRole = this.getDefaultAdminRole(this.adminRoleValues, this.customer);
    this.isRequestCompleted = false;

    this.localStorageService = localStorageService;
    this.useWorkflowValues = [{label: 'Yes', value: 1}, {label: 'No', value: 0}];
    this.defaultUseWorkflow = this.getDefaultUseWorkflow(this.useWorkflowValues, this.customer);
    this.sftpEnabled = false;
    this.importSchemas = [];
    this.exportSchemas = [];
    this.getIntegrations();
  }

  getIntegrations() {
    this.getSchemas()
      .then(this.sortSchemas.bind(this))
      .then(this.setBlankInstances.bind(this))
      .then(this.getIntegrationsForSchemas.bind(this))
      .then(this.loadAgentConfig.bind(this));
  }

  getSchemas() {
    return this.customerIntegrationsService.getSchemas();
  }

  setBlankInstances() {
    _.each(this.schemas, (schema) => {
      _.each(schema.keys, (key, name) => {
        if (name !== 'purchasingAccountNumber') {
          key.instance = new BlankIntegrationInstance(name, schema.type, key.default);
        }
      });
    });
  }

  sortSchemas(response) {
    this.schemas = _.map(response.data.content, (schema, type) => { schema.type = type; return schema; });
    this.importSchemas = _.filter(this.schemas, (schema) => {return schema.direction === 'import';});
    if (!this.isSuperAdmin()) {
      this.importSchemas = _.filter(this.schemas, (schema) => (schema.direction === 'import' && schema.type.toLowerCase() !== 'manual'));
    }
    this.exportSchemas = _.filter(this.schemas, (schema) => {
      return schema.direction === 'export' && schema.type !== 'Engrade' && schema.type !== 'OneRosterApiProviderV1'; });
  }

  getIntegrationsForSchemas() {
    this.customerIntegrationsService.getAllIntegrations({
      customerId: this.customer.id
    })
      .then(this.onIntegrationsReceived.bind(this));
  }

  loadAgentConfig() {
    let customerId = this.customer.id;
    if(customerId) {
      this.customerService.loadAgentConfig(customerId).then((agentConfig) => {
        if(agentConfig.data.content) {
          this.defaultFileFormat =  this.getDefaultFileFormat(this.importSchemas, agentConfig.data.content.format);
        }
      });
    }
  }

  onIntegrationsReceived(response) {
    let integrations = response.data.content;
    integrations.forEach(this.setIntegration.bind(this));
  }

  setIntegration(integration) {
    this.schemas.forEach((schema) => {
      if (integration.type === schema.type) {
        let key = schema.keys[integration.key];
        if (key.instance && integration.key === 'purchasingAccountNumber' && (!Array.isArray(key.instance) && key.instance.value || Array.isArray(key.instance))) {
          if (!Array.isArray(key.instance)) {
            key.instance = [key.instance];
          }
          key.instance.push(integration);
        } else {
          key.instance = integration;
        }
        key.disabled = key.readonly && integration.value;
        schema.enabled = true;
      }
    });
  }

  submitCustomer(customer) {
    this.clearErrors();
    customer.ssoEnabled = this.defaultSsoEnabled.value;
    customer.importMode = this.defaultImportMode.value;
    customer.classNamePattern = this.defaultBuipFormat.value;
    customer.rosterType = this.defaultFileFormat.type;
    customer.orchestrateData = this.defaultOrchestrateData.value;
    customer.integrations = this.getEnabledIntegrations();
    customer.adminRole = this.defaultAdminRole.value;
    customer.useWorkflow = this.defaultUseWorkflow.value;
    if(this.intergationsAreValid(customer)){
      this.customerService.putCustomer(customer).then(this.onPutCustomerSuccess.bind(this)).catch(this.onPutCustomerFailure.bind(this));
    }
  }

  isSuperAdmin() {
    return parseInt(this.localStorageService.get('role')) === ROLES.SUPER_ADMIN;
  }

  intergationsAreValid(customer) {
    let valid = true;
    _.each(customer.integrations, (integration) => {
      _.each(integration, (int) => {
        let schema = _.find(this.schemas, {'type': int.type});
        _.each(schema.keys[int.key].clientValidations, (validation) => {
          if(validation && validation.method === 'isValid'){
            if(!this[validation.method](int)){
              schema.keys[int.key].error = 'CREDENTIALS_NOT_VALID';
              valid = false;
            }
          }
        });
      });
    });
    return valid;
  }

  isValid(integration) {
    return integration && !_.isEmpty(integration.value);
  }

  onPutCustomerSuccess() {
    this.isRequestCompleted = true;
  }

  hasError(key) {
    return (!!key.error);
  }

  onPutCustomerFailure(response) {
    let error = response.data.error;
    let type = error.name.split('.')[0];
    let schema = _.find(this.schemas, {'type': type});
    let errorKey = error.name.split('.')[1];
    if(errorKey){
      let keys = errorKey.split(',');
      keys.forEach((errorKey) => {
        schema.keys[errorKey].error = error.message;
      });
    }
  }

  clearErrors() {
    _.each(this.schemas, (schema) => {
      _.each(schema.keys, (key) => {
        delete key.error;
      });
    });
  }

  close () {
    this.modalLoaderService.close();
  }

  getEnabledIntegrations() {
    let enabledImportIntegrations = [ this.getEnabledInstancesFromSchema(this.defaultFileFormat) ];
    let enabledExportIntegrations = this.getEnabledExportIntegrations();
    let enabledIntegrations = enabledImportIntegrations.concat(enabledExportIntegrations);
    return enabledIntegrations.filter(int => int.length > 0);
  }

  getEnabledInstancesFromSchema (schema) {
    //filter keys which have clientValidation to show/notshow,or else we r returning everythig
    let enabledInstances = _.reject(schema.keys, (key) => {
      return (!_.isEmpty(key.clientValidations) && key.disabled === true);
    });
    return _.compact(_.flatten(_.map(enabledInstances, (key) => {return key.instance;})));
  }

  getEnabledExportIntegrations() {
    let enabledExportSchemas = _.filter(this.exportSchemas, (schema) => { return schema.enabled; });
    return enabledExportSchemas.map((schema) => { return this.getEnabledInstancesFromSchema(schema); });
  }

  getDefaultSsoEnabled (values, customer) {
    let ssoEnabledValue = (customer.ssoEnabled)?1:0;
    return _.find(values, { value: ssoEnabledValue }) || _.find(values, { value: 0 });
  }

  getDefaultUseWorkflow (values, customer) {
    let useWorkflowValue = (customer.useWorkflow)?1:0;
    return _.find(values, { value: useWorkflowValue }) || _.find(values, { value: 0 });
  }

  getDefaultBuipFormat (values, customer) {
    let buipFormat = (customer.classNamePattern)? customer.classNamePattern : 'Name';
    return _.find(values, { value: buipFormat }) || _.find(values, { value: 'Name' });
  }

  getDefaultImportMode (values, customer) {
    let importMode = customer.importMode;
    if (importMode === undefined || importMode === null) {
      importMode = 0;
    }
    return _.find(values, { value: importMode }) || _.find(values, { value: 0 });
  }

  getDefaultOrchestrateData (values, customer) {
    let orchestrateDataValue = (customer.orchestrateData)?1:0;
    return _.find(values, { value: orchestrateDataValue }) || _.find(values, { value: 1 });
  }

  getDefaultFileFormat (values, formatValue) {
    let fileFormat = formatValue;
    let foundFormat = _.find(values, { type: fileFormat });
    return foundFormat;
  }

  getDefaultAdminRole (values, customer) {
    let roleValue = customer.adminRole || 'staff';
    return _.find(values, { value: roleValue }) || _.find(values, { value: 'staff' });
  }

  isSelectInput(key) {
    return (key.input === 'select');
  }

  /**
   * showEl method is use to display fields according to the schema and also enables/disables it based on the validations.
   * @param {Object} key, the field in the schema
   * @param {boolean} updateDefaultFileFormatKey, flag used to make decision on when to update defaultFileFormat object.
   */
  showEl(key, updateDefaultFileFormatKey = true)  {
    let toShow = true;
    let isSet;
    
    key.clientValidations.forEach((validation) => {
      if(validation && (validation.method === 'toShow' || validation.method === 'notToShow')){
        // jshint maxdepth:3
        if (!isSet) {
          if (this[validation.method](validation.conditionField, validation.conditionValue)) {
            isSet = true;
            toShow = isSet;
            if(updateDefaultFileFormatKey && _.has(this.defaultFileFormat.keys, key.instance.key)){
              this.defaultFileFormat.keys[key.instance.key].disabled = false;
            }
          } else {
            toShow = false;
            if(updateDefaultFileFormatKey && _.has(this.defaultFileFormat.keys, key.instance.key)){
              this.defaultFileFormat.keys[key.instance.key].disabled = true;
            }
          }
        }
      }
    });
    return toShow;
  }

  /**
   * showField method is use to display fields according to defaultFileFormat type and name.
   * @param {String} name, the field name
   */
  showField(name) {
    if (this.defaultFileFormat) {
      if (_.includes(['Aeries', 'OneRosterApiV1'], this.defaultFileFormat.type)
        && _.includes(['ced_sftp_user', 'ced_sftp_pass', 'ced_sftp_dir'], name)) {
        return false;
      }
      if (_.includes(['OneRoster'], this.defaultFileFormat.type)
        && _.includes(['ced_sftp_user', 'ced_sftp_pass', 'ced_sftp_dir',
          'consumerKey', 'consumerSecret', 'sftp_uid', 'sftp_gid'], name)) {
        return false;
      }
    }
    return true;
  }

  toShow(conditionField,conditionValue) {
    return this.defaultFileFormat.keys[conditionField].instance.value === conditionValue ? true : false;
  }

  notToShow() {
    return false;
  }
}

ConfigureCustomerController.$inject = ['modalLoaderService', 'localStorageService', 'config', 'httpDim', 'customerService', 'customerIntegrationsService'];

export default ConfigureCustomerController;



// WEBPACK FOOTER //
// ./app/components/configureCustomer/configureCustomer.controller.js